import { useEffect, useState } from "react";
import { useLocale, useService } from "../../../../hooks";

export const useContact = () => {
  const { t } = useLocale();
  const { setTitle } = useService("Meta");
  const { getContactRequest, showAlert } = useService("Misc");
  const [name, setname] = useState<string>("");
  const [email, setemail] = useState<string>("");
  const [company, setcompany] = useState<string>("");
  const [mobile, setmobile] = useState<string>("");
  const [message, setmessage] = useState<string>("");
  const [subject, setsubject] = useState<string>("");

  setTitle(t("contactUs"));

  const sendContactRequest = async (e) => {
    e.preventDefault();
    let error = false,
      errorMsg = "",
      userObject = {
        name,
        subject,
        company,
        email,
        mobile,
        message,
      };
    if (name === "") {
      errorMsg = t("errorMsg.required.name");
      error = true;
    }
    if (email === "") {
      errorMsg = t("errorMsg.required.email");
      error = true;
    }
    if (mobile === "") {
      errorMsg = t("errorMsg.required.mobile");
      error = true;
    }
    if (subject === "") {
      errorMsg = t("errorMsg.required.subject");
      error = true;
    }
    if (message.length < 20) {
      errorMsg = t("errorMsg.validate.message");
      error = true;
    }
    if (!error) {
      const result = await getContactRequest(userObject);
      if (result.status) {
        showAlert({ type: "info", msg: t("success.contactRequestSubmitted") });
        setname("");
        setemail("");
        setmessage("");
        setmobile("");
        setsubject("");
      } else
        showAlert({
          type: "error",
          msg: t("errorMsg.fail.contactRequestSubmitted"),
        });
    } else showAlert({ type: "error", msg: errorMsg });
  };
  return {
    sendContactRequest,
    name,
    setcompany,
    setemail,
    setname,
    email,
    company,
    mobile,
    setmobile,
    subject,
    setsubject,
    message,
    setmessage,
  };
};
